import CheckMarkIcon from './check-mark-icon';
export default CheckMarkIcon;
